module.exports = __webpack_public_path__ + "static/img/materiales_interactivos_icon.381993fe.svg";